// extracted by mini-css-extract-plugin
module.exports = {"root":"_2e3e74"};